// HOOKS
import { useState } from "react";
// COMPONENTS
import LogicalOperatorsDropdown from "./dropdowns/logicalOperators.dropdown.advancedQuery";
import MatchAdvancedQuery from "./match/match.advancedQuery";

const CLASSNAMES = {
  container: "shadow shadow-secondary bg-greenGlass w-full",
};

const MATCH = {
  and: [],
};

const AdvancedQuery = () => {
  const [match, setMatch] = useState(MATCH);
  return (
    <div className={CLASSNAMES.container}>
      <div className="">
        <MatchAdvancedQuery match={match} setMatch={setMatch} />
      </div>
    </div>
  );
};

export default AdvancedQuery;
